import React from 'react';
import { LoanCard } from '../card-lenses';
import State from './state';

const Preapproval = (props) => (
  <State title="Where are you looking for a home?" target="preapprovalState" {...props} />
);
Preapproval.completed = ({ model }) => !!model.get('preapprovalState');
Preapproval.id = 'PreapprovalState';

export const PreapprovalState = LoanCard(Preapproval);

const Purchase = (props) => (
  <State title="Where are you looking for a home?" target="loanState" {...props} />
);
Purchase.completed = ({ model }) => !!model.get('loanState');
Purchase.id = 'loanState';

export const PurchaseState = LoanCard(Purchase);

const Refi = (props) => <State title="Where is your home located?" target="loanState" {...props} />;
Refi.completed = ({ model }) => !!model.get('loanState');
Refi.id = 'loanState';

export const RefiState = LoanCard(Refi);

const Affordability = (props) => (
  <State title="Where are you looking for a home?" target="loanState" {...props} />
);
Affordability.completed = ({ model }) => !!model.get('loanState');
Affordability.id = 'loanState';

export const AffordabilityState = LoanCard(Affordability);



// WEBPACK FOOTER //
// ./src/cards/state/index.js